/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Created.ai API
 * OpenAPI spec version: 1
 */

/**
 * The effects of live's Effects tab (#265), all 102, in its order within each kind, by the
 * slugs of live's keys (`fadeIn` is `fade-in`; spec docs/specs/editor/effects.md).
 */
export type EffectKind = typeof EffectKind[keyof typeof EffectKind];


export const EffectKind = {
  grayscale: 'grayscale',
  sepia: 'sepia',
  invert: 'invert',
  vignette: 'vignette',
  'hue-shift': 'hue-shift',
  'fade-in': 'fade-in',
  'fade-out': 'fade-out',
  'adjustment-filter': 'adjustment-filter',
  'advanced-bloom-filter': 'advanced-bloom-filter',
  'backdrop-blur-filter': 'backdrop-blur-filter',
  'bloom-filter': 'bloom-filter',
  'color-map-filter': 'color-map-filter',
  'convolution-filter': 'convolution-filter',
  'dot-filter': 'dot-filter',
  'glitch-filter': 'glitch-filter',
  'glow-filter': 'glow-filter',
  'godray-filter': 'godray-filter',
  'grayscale-filter': 'grayscale-filter',
  'hsl-adjustment-filter': 'hsl-adjustment-filter',
  'kawase-blur-filter': 'kawase-blur-filter',
  'motion-blur-filter': 'motion-blur-filter',
  'old-film-filter': 'old-film-filter',
  'radial-blur-filter': 'radial-blur-filter',
  'reflection-filter': 'reflection-filter',
  'rgb-split-filter': 'rgb-split-filter',
  'tilt-shift-filter': 'tilt-shift-filter',
  'rotation-movement': 'rotation-movement',
  spring: 'spring',
  'warp-transition': 'warp-transition',
  'pixelate-transition': 'pixelate-transition',
  'focus-transition': 'focus-transition',
  'scale-move-blur': 'scale-move-blur',
  'camera-move': 'camera-move',
  'fast-zoom': 'fast-zoom',
  'camera-shake': 'camera-shake',
  'radial-zoom-rush': 'radial-zoom-rush',
  'zoom-rotate': 'zoom-rotate',
  'dutch-tilt-recoil': 'dutch-tilt-recoil',
  'whip-snap-punch': 'whip-snap-punch',
  'earthquake-tremor': 'earthquake-tremor',
  shine: 'shine',
  blink: 'blink',
  'flash-loop': 'flash-loop',
  'neon-flash': 'neon-flash',
  laser: 'laser',
  sparks: 'sparks',
  'black-flash': 'black-flash',
  'bright-pulse': 'bright-pulse',
  strobe: 'strobe',
  'edge-glow': 'edge-glow',
  'anamorphic-streak': 'anamorphic-streak',
  'lens-glint-rainbow': 'lens-glint-rainbow',
  'solarize-flare': 'solarize-flare',
  glitch: 'glitch',
  'rgb-glitch': 'rgb-glitch',
  'rgb-shift': 'rgb-shift',
  'slit-scan': 'slit-scan',
  'slit-scan-glitch': 'slit-scan-glitch',
  'tv-scanlines': 'tv-scanlines',
  'rgb-split-pulse': 'rgb-split-pulse',
  'vhs-tape-fx': 'vhs-tape-fx',
  'datamosh-melt': 'datamosh-melt',
  'bad-antenna-static': 'bad-antenna-static',
  'pixel-sorting': 'pixel-sorting',
  halftone: 'halftone',
  'film-strip-pro': 'film-strip-pro',
  'paper-break-reveal': 'paper-break-reveal',
  'film-grain': 'film-grain',
  kodachrome8mm: 'kodachrome8mm',
  'technicolor-two-strip': 'technicolor-two-strip',
  'aged-newspaper': 'aged-newspaper',
  sinewave: 'sinewave',
  'swirl-movement': 'swirl-movement',
  distort: 'distort',
  'perspective-single': 'perspective-single',
  'distort-spin': 'distort-spin',
  'distort-grid': 'distort-grid',
  'mirror-tile': 'mirror-tile',
  'curtain-open': 'curtain-open',
  'curtain-blur': 'curtain-blur',
  'distort-v2': 'distort-v2',
  'wave-distort': 'wave-distort',
  wave: 'wave',
  heatwave: 'heatwave',
  'fisheye-barrel': 'fisheye-barrel',
  'underwater-refraction': 'underwater-refraction',
  'black-hole-vortex': 'black-hole-vortex',
  'heart-sparkles': 'heart-sparkles',
  'golden-glitter': 'golden-glitter',
  'bubble-sparkles': 'bubble-sparkles',
  'fairy-dust': 'fairy-dust',
  pixelate: 'pixelate',
  duotone: 'duotone',
  tritone: 'tritone',
  chromatic: 'chromatic',
  'inverse-aperture': 'inverse-aperture',
  hdr: 'hdr',
  'hdr-v2': 'hdr-v2',
  'chromatic-aura': 'chromatic-aura',
  'cyberpunk-neon': 'cyberpunk-neon',
  'thermal-infrared': 'thermal-infrared',
  'cinematic-teal-orange': 'cinematic-teal-orange',
} as const;
